import React, { useState } from "react";
import { gql, useMutation } from "@apollo/client";
import { FETCH_TRANSACTIONS_QUERY } from "../graphql";
import { Radio, RadioGroup } from "@chakra-ui/react";
import { Wrap, WrapItem } from "@chakra-ui/react";
import { Grid, GridItem } from "@chakra-ui/react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const AddTransaction = ({ user }) => {
  const [text, setText] = useState("");
  const [amount, setAmount] = useState("");
  const [desc, setDesc] = useState("");

  const ADD_TRANSACTION = gql`
    mutation addItem(
      $category: String!
      $user: String!
      $value: Float!
      $createdAt: String!
      $desc: String!
    ) {
      addItem(
        addTransaction: {
          category: $category
          user: $user
          value: $value
          createdAt: $createdAt
          desc: $desc
        }
      ) {
        id
        category
        user
        value
        createdAt
        desc
      }
    }
  `;
  const [addFunction] = useMutation(ADD_TRANSACTION, {
    refetchQueries: [{ query: FETCH_TRANSACTIONS_QUERY }],
  });

  const onSubmit = (e) => {
    e.preventDefault();
    if (text === "") {
      alert("Select Category");
      return false;
    }
    let a = +amount;
    if (text !== "Income") {
      a *= -1;
    }
    if (text !== "Youth Allowance") {
      a *= -1;
    }
    if (text !== "Interest") {
      a *= -1;
    }

    addFunction({
      variables: {
        category: text,
        user: user,
        value: a,
        createdAt: new Date().toISOString(),
        desc: desc,
      },
    });

    toast("Added!");
    setAmount("")
    setDesc("")

  };

  return (
    <>
      <h2>New Transaction</h2>
      <form onSubmit={onSubmit}>
        <div className="form-control">
          <Wrap>
            <RadioGroup onChange={setText} value={text}>
              <Grid templateColumns="repeat(5, 1fr)" gap={10}>
                <GridItem>
                  <WrapItem>
                    <Radio colorScheme="green" value="Income">
                      Income
                    </Radio>
                  </WrapItem>
                  <WrapItem>
                    <Radio colorScheme="green" value="Youth Allowance">
                      Youth Allowance
                    </Radio>
                  </WrapItem>
                  <WrapItem>
                    <Radio colorScheme="green" value="Interest">
                      Interest
                    </Radio>
                  </WrapItem>
                  <WrapItem>
                    <Radio colorScheme="red" value="Groceries">
                      Groceries
                    </Radio>
                  </WrapItem>
                  <WrapItem>
                    <Radio colorScheme="red" value="Restaurants/Dining">
                      Restaurants/Dining
                    </Radio>
                  </WrapItem>
                </GridItem>
                <GridItem>
                  <WrapItem>
                    <Radio colorScheme="red" value="Shopping/Entertainment">
                      Shopping/Entertainment
                    </Radio>
                  </WrapItem>
                  <WrapItem>
                    <Radio colorScheme="red" value="Transportation">
                      Transportation
                    </Radio>
                  </WrapItem>
                  <WrapItem>
                    <Radio colorScheme="red" value="Bills">
                      Bills
                    </Radio>
                  </WrapItem>
                  <WrapItem>
                    <Radio colorScheme="red" value="Misc">
                      Misc
                    </Radio>
                  </WrapItem>
                </GridItem>
              </Grid>
            </RadioGroup>
          </Wrap>
        </div>
        <div className="form-control">
          <label htmlFor="amount">
            Amount <br />
          </label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter amount..."
          />
          <label htmlFor="text">Category</label>
          <input
            type="text"
            value={desc}
            onChange={(e) => setDesc(e.target.value)}
            placeholder="Enter description..."
          />
        </div>
        <button className="btn">Add transaction</button>
        <ToastContainer position="bottom-center" autoClose={300} hideProgressBar={true} pauseOnHover={false}/>
      </form>
      <br/>
      <br/>
      <br/>
    </>
  );
};
